module.exports = __webpack_public_path__ + "static/media/east_mediterranean.330ca056.png";